/* eslint-disable @typescript-eslint/no-explicit-any */
import { MenuItemSelector } from "features/journey-map/swimlanes/card-components/MenuItemSelector";
import { OpportunityAdvancedSearchModal } from "features/journey-map/swimlanes/opportunities/modals/OpportunityAdvancedSearchModal";
import { createOpportunity } from "features/opportunity/reducer/OpportunityActions";
import { useSelector } from "react-redux";
import { retrieveAllActiveOpportunities } from "redux/memoizedSelectors";
import EditModeSwitch from "shared/components/edit-mode-switch";
import GenericTypeahead from "shared/dropdowns/GenericTypeahead";
import CreateNewItem from "shared/dropdowns/cx-dropdown/components/create-new-item";
import { SwitchProvider } from "shared/dynamic-imports";
import PriorityItem from "shared/ui-basics/ui-components/PriorityItem";
import Tag from "shared/ui-basics/ui-components/tag";
import { EMPTY_GUID, encode, getCxAttribute, StripHtml } from "utils/helpers";
import { InformationType } from "utils/optionsSets/OptionSets";
import { v4 as uuid } from "uuid";
import RenderAdvancedModalFooter from "../components/RenderAdvancedFooter";
import { useAIParams } from "./OpportunityDropdownAI";

interface OpportunityDropdownProps {
	link?: (id: string, e?: any) => void;
	closeDropdown?: () => void;
	selected?: any;
	menuListHeight?: string;
	isOpen?: boolean;
	isSwitchDisabled?: boolean;
	isCloseAfterCreate?: boolean;
	showShadow?: boolean;
	globalWidth?: string;
	aiParameters?: any;
}

export const OpportunityDropdown = ({
	selected,
	link,
	menuListHeight,
	closeDropdown,
	isOpen = false,
	isSwitchDisabled = false,
	isCloseAfterCreate = false,
	showShadow = false,
	globalWidth,
	aiParameters, // stageName, cjmDescription, swimlaneKey, stageId
}: OpportunityDropdownProps): JSX.Element => {

	const allOpportunities: any[] = useSelector(retrieveAllActiveOpportunities);
	const priorities: any[] = useSelector((state: any) => state?.libraries?.priority?.opportunity);
	const aiParams = useAIParams({ aiParameters, closeDropdown, link });

	const handleCreate = ({ input, clearInput, close }: any) => {
		clearInput();
		if (isCloseAfterCreate) close();
		const onSuccess = (item: any) => {
			if (link)
				link(item?.id)

		}
		const params: any = { item: { id: uuid(), name: encode(input.truncate(100, true)) }, onSuccess: link ? onSuccess : null };
		createOpportunity(params);
	};

	const params: any = {
		selected: [],
		options: allOpportunities,
		placeholder: "SEARCH_OR_CREATE",
		menuLabel: "SELECT_OR_CREATE",
		renderSelectedItem: () => <></>,
		renderMenuItem: ({ item }: any) => {
			const priorityAttribute = getCxAttribute({ data: item, informationType: InformationType.Priority });
			const priority = priorities?.find((p) => p.id === priorityAttribute?.priorityId);
			const handleLink = (e: any) => {
				if (link) link(item?.id, e);
			}
			return (
				<div className="item-dropdown-typehead-generic" onClick={handleLink}>
					<MenuItemSelector
						id={item?.id}
						title={item?.name?.defaultPlaceholder("OPPORTUNITY_NAME")}
						description={StripHtml(item?.description || "")}
						renderLabel={() => <PriorityItem priority={priority} />}
                        icon="OPPORTUNITY"
                        classNames="p-2"
					/>
				</div>
			);
		},
		linkMenuItem: ({ item }: any) => {
			if (link) link(item?.id);
		},
		filter: ({ query, option }: any) => {
			const opp = allOpportunities.find((t) => t.id === option?.id);
			if (opp && !selected?.includes(opp.id)) return opp?.name?.toLowerCase().includes(query?.toLowerCase());
		},
		renderCreateItem: ({ input, clearInput, close }: any) => (
			<CreateNewItem create={() => handleCreate({ input, clearInput, close })} renderItem={() => <Tag tag={{ id: EMPTY_GUID, name: input, colorCode: "#ffffff" }} />} createLabel="JS_87" />
		),

		menuListHeight,
		isStrictOpen: isOpen ? isOpen : null,
		RenderFooter: RenderAdvancedModalFooter({ closeDropdown, link, selected, modal: OpportunityAdvancedSearchModal }),
		showShadow,
		globalWidth,
		virtualScrollerParams: {
			rowHeight: 96,
		},
		...aiParams,
	};

	return (
		<SwitchProvider initialValue={isOpen} isDisabled={isSwitchDisabled} >
			<EditModeSwitch addLabel="OPPORTUNITY" isDisabled={isSwitchDisabled} isEmpty={true}>
				<GenericTypeahead {...params} />
			</EditModeSwitch>
		</SwitchProvider>
	);
};

